import React, { useEffect } from "react";
import { useState } from "react";
import { useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import ErrorText from "../common/ErrorText";
import styles from "../../Styles/modal.module.css";
import CloseIcon from "@mui/icons-material/Close";
import ReCAPTCHA from "react-google-recaptcha";
import apiCall from "../../helpers/apifactory";

const Careers = () => {
  // useEffect(() => {
  //   let current_page = window.location.href.split("/").at(-1);
  //   setTimeout(() => {
  //     document
  //       .getElementById(`${current_page}`)
  //       .scrollIntoView({ block: "center", behavior: "smooth" });
  //   }, 100);
  // });
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
      top > header_height && window_width > 1024
        ? document.querySelector("a").classList.add("fixed-header-desktop")
        : document.querySelector("a").classList.remove("fixed-header-desktop");
    },
    false,
  );
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      top > header_height && window_width > 1024
        ? document.querySelector("nav").classList.add("fixed-header-desktop")
        : document
            .querySelector("nav")
            .classList.remove("fixed-header-desktop");
      // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    },
    false,
  );

  const inputRef = useRef(null);

  const [show, setShow] = useState(false);
  const modalRef = useRef(null);

  useEffect(() => {
    if (show) {
      modalRef.current.classList.add(styles.visible);
    } else {
      modalRef.current.classList.remove(styles.visible);
    }
  }, [show]);

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      number: "",
      relocate: "yes",
      att: null,
      linkedIn: "",
      website: "",
      recaptcha: "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("This is Required"),
      lastName: Yup.string().required("This is Required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("This is Required"),
      number: Yup.string()
        .matches(/^((\+92)?(0092)?(92)?(0)?)(3)([0-9]{9})$/gm, {
          message: "Invalid phone number",
          excludeEmptyString: false,
        })
        .required("This is Required"),
      relocate: Yup.string().required("This is Required"),
      att: Yup.object().required("This is Required"),
      linkedIn: Yup.string().required("This is Required"),
      website: Yup.string(),
      recaptcha: Yup.string().required(),
    }),
    onSubmit: (values) => {
      const body = {
        toEmailID: "talent.acquisition@tcs.com.pk",
        emailSubject: "Careers Request",
        emailText: `
            firstName: ${values?.firstName} \n
            lastName: ${values?.lastName} \n
            email: ${values?.email} \n
            number: ${values?.number} \n
            relocate: ${values?.relocate} \n
            linkedIn: ${values?.linkedIn} \n
            website: ${values?.website} \n
          `,
        cc: values?.email,
        bcc: values?.email,
        attachments: [values.att],
        replyTo: values?.custEmail,
      };
      // const header = {
      //   Authorization: `Bearer ${'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjpbIk5vdGlmaWNhdGlvbiIsIkludGVybmF0aW9uYWxCb29raW5nIiwiVHJhY2siLCJUVEMiLCJGU1AiLCJDbGFpbVNlcnZpY2UiLCJXTVMiLCJHU00iLCJSTVMiLCJXb3JrZmxvdyIsIkNMUyJdLCJjbGllbnRpZCI6IjIxMTExMTExMSIsImF1ZCI6WyJtaWRkbGV3YXJlLnRyYW56dW1way5jb20iLCJtaWRkbGV3YXJlLnRyYW56dW1way5jb20iXSwiaXNzIjoibWlkZGxld2FyZS50cmFuenVtcGsuY29tIiwianRpIjoiNjFmNzllZTgtMDZjNi00NmY0LWExM2MtNWUwOWZjODU4Mzg1IiwibmJmIjoxNjczMjc4MTU4LCJleHAiOjE3NTk2NzQ1NTgsImlhdCI6MTY3MzI3ODE1OH0.FVA0xgGz6BjVdbXglSR94to8oSTZEaMWxRVWTP8DC38'}`,
      // };
      apiCall
        .sendEmail(body, {})
        .then((res) => {
          setShow(true);
          formik.setValues(formik?.initialValues);
          formik.setTouched({}, false);
        })
        .catch((error) => {
          console.log("===============", error);
        });
    },
  });
  const convertBase64 = (file, e) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
        formik?.setFieldValue("att", {
          fileName: e?.target?.files[0]?.name,
          contentType: "application/octet-stream", //contentType: e?.target?.files[0]?.type,
          base64File: fileReader?.result?.split(",")[1],
        });
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };
  const handleFileRead = async (event) => {
    const file = event.target.files[0];
    await convertBase64(file, event);
  };

  return (
    <div>
      <div className="bg-[#efefef] flex justify-center items-center h-[150px]">
        <h1 className="text-[40px] font-bold">Careers</h1>
      </div>

      <div className="my-[3rem]">
        <div
          onSubmit={(e) => e.preventDefault()}
          className="flex flex-col justify-center mt-[1rem] mb-[1rem] "
        >
          <div className="flex flex-col gap-3 p-2 sm:p-8 shadow-card text-sm md:w-[45rem] sm:w-[40rem] w-[auto] mx-[1rem] sm:mx-[auto] rounded-md transition-all duration-500">
            <div className="gap-4 mt-4">
              <div className="flex-1 flex flex-col gap-1">
                <h2 className="font-bold text-[1.1rem] text-left sm:pb-[0rem] sm:pl-[0rem] pb-[1rem] pl-[1.2rem]">
                  Application for Job
                </h2>
                <div className="flex gap-4 ">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="firstName"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="firstName"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.firstName}
                      />
                      <label
                        for="firstName"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        First Name <span className="text-[#F21E26]">*</span>
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.firstName && formik?.errors?.firstName
                      }
                    />
                  </div>

                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="lastName"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="lastName"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.lastName}
                      />
                      <label
                        for="lastName"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Last Name <span className="text-[#F21E26]">*</span>
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.lastName && formik?.errors?.lastName
                      }
                    />
                  </div>
                </div>
                <div className="sm:flex grid gap-4 ">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="email"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="email"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.email}
                      />
                      <label
                        for="email"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Email Address <span className="text-[#F21E26]">*</span>
                      </label>
                    </div>
                    <ErrorText
                      text={formik?.touched?.email && formik?.errors?.email}
                    />
                  </div>

                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="number"
                        id="number"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="number"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.number}
                      />
                      <label
                        for="number"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Contact Number <span className="text-[#F21E26]">*</span>
                      </label>
                    </div>
                    <ErrorText
                      text={formik?.touched?.number && formik?.errors?.number}
                    />
                  </div>
                </div>
                <div className="sm:flex grid gap-4 ">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <select
                        id="relocate"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="relocate"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.relocate}
                      >
                        <option>Yes</option>
                        <option>No</option>
                      </select>
                      <label
                        for="relocate"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Willing to Relocate{" "}
                        <span className="text-[#F21E26]">*</span>
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.relocate && formik?.errors?.relocate
                      }
                    />
                  </div>
                  <div className="sm:w-[20rem]">
                    <div className="attachment relative  text-black  rounded-md  p-[.2rem] mt-0 border-grey-10">
                      <div className="flex justify-between rounded-md border-grey-700">
                        <p className="relative   text-[grey] text-xs rounded-sm  p-[.2rem]">
                          {formik?.values?.att
                            ? formik?.values?.att?.fileName
                            : "Attach Resume/CV"}
                        </p>

                        <button onClick={(e) => inputRef.current.click(e)}>
                          <img
                            src="/Home/paperclip.svg"
                            className="-rotate-45"
                            alt=""
                          />
                        </button>
                      </div>
                      <input
                        id="fileUpload"
                        type="file"
                        multiple
                        style={{ display: "none" }}
                        accept="application/pdf, image/png"
                        onChange={handleFileRead}
                        name="att"
                        onBlur={formik.handleBlur}
                        ref={inputRef}
                      />
                    </div>
                    <ErrorText
                      text={formik?.touched?.att && formik?.errors?.att}
                    />
                  </div>
                </div>
                <div className="flex gap-4  ">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="linkedIn"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="linkedIn"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.linkedIn}
                      />
                      <label
                        for="linkedIn"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        LinkedIn Profile{" "}
                        <span className="text-[#F21E26]">*</span>
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.linkedIn && formik?.errors?.linkedIn
                      }
                    />
                  </div>
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="website"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="website"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.website}
                      />
                      <label
                        for="website"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Website
                      </label>
                    </div>
                    <ErrorText
                      text={formik?.touched?.website && formik?.errors?.website}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*  */}
          <div className="flex flex-col justify-center mt-[1rem] sm:mx-[auto]">
            <div className="flex gap-4 md:w-[45rem] sm:w-[43rem] w-[auto] mx-[1rem] sm:mx-[auto]">
              <div className="g-recaptcha">
                <ReCAPTCHA
                  sitekey={process.env.REACT_APP_CAPTCH}
                  onChange={(value) => {
                    formik.setFieldValue("recaptcha", value);
                  }}
                />
              </div>
            </div>
          </div>
          {/*  */}
          <button
            onClick={formik?.handleSubmit}
            type="submit"
            className="text-white bg-[#D40511] border border-[#F21E26] md:w-[45rem] sm:w-[40rem] w-[auto] mx-[1rem] sm:mx-[auto] rounded-md mt-1 p-1 h-[2.5rem] text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500"
          >
            Submit
          </button>
        </div>
      </div>
      <div
        ref={modalRef}
        // style={backdropStyle}
        className={`${styles.modal__wrap}`}
        onClick={() => setShow(false)}
      >
        <div
          className={`flex flex-col justify-center items-center ${styles.modal}`}
        >
          <div className="bg-white w-full h-[106%] relative z-[1000] rounded-3xl">
            <div className="flex justify-center items-center">
              <img
                src="/popup-circle.png"
                alt=""
                className="mx-auto w-[12.5rem]"
              />
              <img
                src="/popup-icon.png"
                alt=""
                className="absolute top-[-3.5rem] mx-auto w-[7rem]"
              />
            </div>
            <div className="absolute right-[1rem] top-[1rem] ">
              <CloseIcon fontSize="large" style={{ color: "#f21e26" }} />
            </div>
            <div className="flex flex-col text-center justify-center item-center mt-[6rem]">
              <h2 className="font-bold text-xl">Thank you for submitting.</h2>
              <p>We’ll contact you soon.</p>
            </div>
          </div>
          <div className="mx-auto bg-[#ed1d25] w-[80%] h-[2rem] rounded-full mt-[-1.2rem]"></div>
        </div>
      </div>
    </div>
  );
};

export default Careers;
